import React from "react";
import Review from "../components/Review/Review";
import { Helmet } from "react-helmet";
import { APP_TITLE } from "../constants/title";
import Layout from "../components/Layout/Layout";

const RecenzeView = () => {
  return (
    <>
      <Layout title={"Recenze"}>
        <Review />
      </Layout>
    </>
  );
};

export default RecenzeView;
